import { Grid } from "@mui/material";
import { observer } from "mobx-react";
import React from "react";
import { useStore } from "utils/useStore";
import { LLMClassifierBuilderStore } from "../Stores/LLMClassifierBuilderStore";
import { ConversationFilters } from "./ConversationFilters";
import { DataLabelingModuleAndQuestionSelectors } from "./DataLabelingModuleAndQuestionSelector";

/** The question and filters that pick the Data step's labeled conversations. */
export const TestSetFields = observer(() => {
    const store = useStore(LLMClassifierBuilderStore);

    return (
        <Grid
            container
            direction="column"
            flexWrap="nowrap"
            rowGap={2}
            width="100%"
        >
            <DataLabelingModuleAndQuestionSelectors />
            <ConversationFilters filters={store.dataStepFilters} fullWidth />
        </Grid>
    );
});
